import React from 'react';
import styled from 'styled-components';
import CustomButton from '../CustomButton';
import { useTranslation } from 'react-i18next';

const TargetButtons = styled.div`
  position: absolute;
  z-index: 3;
  top: ${({ y }) => y + 'px'};
  left: ${({ x }) => x + 'px'};
  transform: translateY(-100%);
  pointer-events: auto;
  display: flex;
  margin: 0;
  padding: 0;
  button {
    &:first-child {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      background-color: #cce5ff
    }
    &:last-child {
      border-left: none;
      background-color: #cce5ff;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    width: fit-content !important;
    border: 1px solid #0073ea;
    color: black;
  }
`;

const SignatureConatiner = styled.div`
  width: ${({ width }) => width + 'px'};
  height: ${({ height }) => height + 'px'};
  position: absolute;
  z-index: 1;
  top: ${({ y }) => y + 'px'};
  left: ${({ x }) => x + 'px'};
  object-fit: contain;
  pointer-events: auto;
  background-color: transparent;
  color-scheme: only light;
  forced-color-adjust: none;
  border-radius: 4px;

  img {
    box-sizing: content-box;
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
    padding: 0;
    border: 2px dashed #0073ea;
    margin: 0;
    background-color: transparent;
    color-scheme: only light;
    forced-color-adjust: none;
  }
`;

const SignatureImage = ({
  noPadding=false,
  image,
  x,
  y,
  fieldDimensions,
  handleDelete,
  handleEdit,
}) => {
  const { t } = useTranslation();
  const heightOfImageContainer = fieldDimensions?.height || 60;
  const widthOfImageContainer = fieldDimensions?.width || 60;
  const heightOfImage = image?.height || 40;
  const widthOfImage = image?.width || 60;
  const paddingX = noPadding ? 0 : 6;
  const paddingY = noPadding ? 0 : 40;

  let calculatedHeight, calculatedWidth;
  calculatedWidth =
    widthOfImage > widthOfImageContainer ? widthOfImageContainer : widthOfImage;
  calculatedHeight = (heightOfImage * calculatedWidth) / widthOfImage;

  if (calculatedHeight > heightOfImageContainer) {
    calculatedHeight = heightOfImageContainer;
    calculatedWidth = (widthOfImage / heightOfImage) * calculatedHeight;
  }

  return (
    image && (
      <>
        <TargetButtons x={x+paddingX} y={y-paddingY}>
          <CustomButton key="delete" onClick={handleDelete}>
            {t('Delete')}
          </CustomButton>
          <CustomButton key="edit" onClick={handleEdit}>
            {t('Edit')}
          </CustomButton>
        </TargetButtons>
        <SignatureConatiner
          x={x+paddingX}
          y={y+paddingX}
          id="target-container"
          height={calculatedHeight || 40}
          width={calculatedWidth || 60}
        >
          <img src={image?.src} alt="sender signature" id="target-image"></img>
        </SignatureConatiner>
      </>
    )
  );
};

export default SignatureImage;
